import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Table, Text, ActionLink, stickyHeader, stickyStyle } from '@custom-components';
import { addCommas } from '../../../../lib/utils';

import { OverflowContainer, PulseWrapper } from '../List.styles';

class AddTaxesTable extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string,
        amount: PropTypes.number,
        taxFeeType: PropTypes.string,
        category: PropTypes.string,
        appliedTo: PropTypes.string,
        calculatedOn: PropTypes.string,
        maxDays: PropTypes.number
      })
    ).isRequired,
    messages: PropTypes.shape({}),
    handleAdd: PropTypes.func.isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    calculatedOn: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    appliedTo: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  };

  static defaultProps = {
    messages: {
      nameLabel: 'Name',
      categoryLabel: 'Category',
      amountLabel: 'Amount',
      calcLabel: 'Calculated On',
      appliedLabel: 'Applied To',
      maxDaysLabel: 'Max Days',
      actionHeaderLabel: ''
    }
  };

  resolveMessages = () => {
    const { messages } = this.props;
    return { ...AddTaxesTable.defaultProps.messages, ...messages };
  };

  renderRows = () => {
    const { data, handleAdd, categories, calculatedOn, appliedTo } = this.props;

    if (!data) return null;

    return data.map((tax) => {
      const { id, name, category, amount, type, maxDays } = tax;
      return {
        id,
        name,
        category: (categories.find((c) => c.value === category) || {}).label,
        amount: addCommas(
          type === 'Percent' ? `${Number.isInteger(amount) ? amount.toFixed(1) : amount}%` : `$${amount.toFixed(2)}`
        ),
        calcOn: (calculatedOn.find((item) => item.value === tax.calculatedOn) || {}).label,
        applied: (appliedTo.find((item) => item.value === tax.appliedTo) || {}).label,
        maxDays,
        action: (
          <ActionLink onClick={() => handleAdd(tax)}>
            <Text.HeadingSixth noMargins>Add Tax</Text.HeadingSixth>
          </ActionLink>
        )
      };
    });
  };

  render() {
    const { nameLabel, categoryLabel, amountLabel, calcLabel, appliedLabel, maxDaysLabel, actionHeaderLabel } =
      this.resolveMessages();
    return (
      <OverflowContainer>
        <PulseWrapper>
          <Table
            minWidth="100%"
            headerCellsConfig={{ action: { style: stickyHeader } }}
            contentCellsConfig={{ action: { style: stickyStyle } }}
            rows={[
              { id: 'name', label: nameLabel },
              { id: 'category', label: categoryLabel },
              { id: 'amount', label: amountLabel },
              { id: 'calcOn', label: calcLabel },
              { id: 'applied', label: appliedLabel },
              { id: 'maxDays', label: maxDaysLabel },
              { id: 'action', label: actionHeaderLabel }
            ]}
          >
            {this.renderRows()}
          </Table>
        </PulseWrapper>
      </OverflowContainer>
    );
  }
}

export default AddTaxesTable;
